import { withProfiler } from '@do/seashell/utils';
import React, { ReactElement, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ExperimentationProviders from './components/ExperimentationProviders';
import InterstitialRegistration from './components/InterstitialRegistration';
import Login from './components/Login';
import PasswordForgot from './components/PasswordForgot';
import PasswordReset from './components/PasswordReset';
import { FORCE_NEW_BRAND_DESIGN } from './constants';
import { ArkoseContextProvider } from './providers/ArkoseContext';

const NewStyle = React.lazy(() => import('./components/newBrandDesign/Style'));

interface Analytics extends SegmentAnalytics.AnalyticsJS {
  initialized: boolean | undefined;
  invoked: boolean | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  track: (event: string, props: any) => void;
}

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setupEnforcement?: (enforcement: any) => void;
    analytics?: Analytics;
  }
}

const NoStyle = (): ReactElement | null => <React.Fragment></React.Fragment>;

const StyleComponent: React.FC<{
  children: React.ReactNode;
  isNewBrandDesignEnabled: boolean;
}> = ({ children, isNewBrandDesignEnabled }): ReactElement => {
  return (
    <>
      <React.Suspense fallback={<></>}>
        {isNewBrandDesignEnabled ? <NewStyle /> : <NoStyle />}
      </React.Suspense>
      {children}
    </>
  );
};

export function App(): ReactElement {
  const [isNewBrandDesignEnabled, setIsNewBrandDesignEnabled] = useState(
    FORCE_NEW_BRAND_DESIGN
  );

  return (
    <ArkoseContextProvider>
      <BrowserRouter>
        <ExperimentationProviders
          setIsNewBrandDesignEnabled={setIsNewBrandDesignEnabled}
        >
          <StyleComponent isNewBrandDesignEnabled={isNewBrandDesignEnabled}>
            <Routes>
              <Route
                path="/registrations/new"
                element={
                  <InterstitialRegistration
                    isNewBrandDesignEnabled={isNewBrandDesignEnabled}
                  />
                }
              />
              <Route
                path="/registration-next"
                element={
                  <InterstitialRegistration
                    isNewBrandDesignEnabled={isNewBrandDesignEnabled}
                  />
                }
              />
              <Route
                path="/login"
                element={
                  <Login isNewBrandDesignEnabled={isNewBrandDesignEnabled} />
                }
              />
              <Route
                path="/forgot_password/new"
                element={
                  <PasswordForgot
                    isNewBrandDesignEnabled={isNewBrandDesignEnabled}
                  />
                }
              />
              <Route
                path="/password_resets/:token"
                element={
                  <PasswordReset
                    isNewBrandDesignEnabled={isNewBrandDesignEnabled}
                  />
                }
              />
            </Routes>
          </StyleComponent>
        </ExperimentationProviders>
      </BrowserRouter>
    </ArkoseContextProvider>
  );
}

export default withProfiler(App);
